import { calculateAmountWithDiscount, formatAmount } from '../../../utils/price/price.utils';
import { CouponForm } from '../../steps/PaymentStep/CouponForm';
import {
  CouponRow,
  GreenText,
  KlarnaSubtitle,
  PaymentSummaryWrapper,
  PlanNameRow,
  SubtotalRow,
  SummaryDivider,
  SummaryRowItem,
  TotalSumRow,
} from './PaymentSummary.style';
import { Discount } from '../../steps/PaymentStep/paymentStep.types';
import { useMst } from '../../../models/rootModel';

export interface PaymentSummaryProps {
  planName: string;
  planMonthlyPriceShort: number;
  planWeeklyPriceShort: number;
  planPriceInCents: number;

  planCurrency: string;

  appliedDiscount?: Discount | null;
  showCouponForm?: boolean;
}

export const PaymentSummary: React.FC<PaymentSummaryProps> = ({
  planPriceInCents,
  appliedDiscount,
  planMonthlyPriceShort,
  planCurrency,
  planWeeklyPriceShort,
  planName,
  showCouponForm,
}) => {
  const {
    UserPayment: { enableProgram, klarnaOnly },
  } = useMst();

  const priceWithDiscount = calculateAmountWithDiscount(planPriceInCents, appliedDiscount);
  const priceOff = planPriceInCents - calculateAmountWithDiscount(planPriceInCents, appliedDiscount);
  const totalPriceFormatted = formatAmount(priceWithDiscount);
  const priceOffFormatted = formatAmount(priceOff);
  const planPriceWithoutDiscountFormatted = formatAmount(planPriceInCents);
  const pricePerPeriod =
    enableProgram && !klarnaOnly
      ? ''
      : !!planMonthlyPriceShort
      ? `${planCurrency}${planMonthlyPriceShort}/mo`
      : !!planWeeklyPriceShort
      ? `${planCurrency}${planWeeklyPriceShort}/week`
      : '';

  return (
    <PaymentSummaryWrapper>
      <PlanNameRow>
        <SummaryRowItem>{planName}</SummaryRowItem>
        <SummaryRowItem>{pricePerPeriod}</SummaryRowItem>
      </PlanNameRow>

      {showCouponForm && <CouponForm />}

      <SubtotalRow>
        <SummaryRowItem>Subtotal</SummaryRowItem>
        <SummaryRowItem>
          {planCurrency}
          {planPriceWithoutDiscountFormatted}
        </SummaryRowItem>
      </SubtotalRow>

      {appliedDiscount && (
        <CouponRow>
          <SummaryRowItem>
            Discount <GreenText>{appliedDiscount.code}</GreenText>
          </SummaryRowItem>
          <SummaryRowItem>
            <GreenText>
              - {planCurrency}
              {priceOffFormatted}
            </GreenText>
          </SummaryRowItem>
        </CouponRow>
      )}

      <SummaryDivider />

      <TotalSumRow>
        <SummaryRowItem>Total</SummaryRowItem>
        <SummaryRowItem>
          {planCurrency}
          {totalPriceFormatted}
        </SummaryRowItem>
      </TotalSumRow>
      {enableProgram && klarnaOnly && <KlarnaSubtitle>Subject to Klarna fees</KlarnaSubtitle>}
    </PaymentSummaryWrapper>
  );
};
